export default __webpack_public_path__ + "static/media/swap.f6ed080f.svg";